import {Outlet} from "react-router-dom";

export default function RulesPermissions() {
    // This Component Use For Rules & Permissions
    return (
        <div className='container'>
            <Outlet/>
        </div>
    )
}